import { FETCH_DEBTS_RESULT } from "../actions/index";

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_DEBTS_RESULT:
      const debtor = action.payload[0].debtor;
      const debts = action.payload[1].debts;
      const installments = action.payload[2].installments;

      return { ...state, debtor, debts, installments };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/Debts.js